<cs-header [disableHideOnScroll]="true" [backButton]="false">
  <cs-header-title [small]="true">
    {{ header || LL.helpCard.title() }}
    <cs-header-title-action>
      <div class="close-button" (click)="close()">
        <cs-icon name="close"></cs-icon>
      </div>
    </cs-header-title-action>
  </cs-header-title>
</cs-header>

<cs-content>
  <div class="content-wrapper">
    <cs-markdown [helpId]="helpId" (textTitleChange)="onHeaderChange($event)"></cs-markdown>
  </div>
</cs-content>
